module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.0509ab0.woff2";